import Icon from '../components/Icon.vue'

Icon.register({
  'chess-queen': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M436 512H76C69.4 512 64 506.6 64 500V476C64 469.4 69.4 464 76 464H436C442.6 464 448 469.4 448 476V500C448 506.6 442.6 512 436 512zM255.6 0C224.7 0 199.6 25.1 199.6 56S224.7 112 255.6 112 311.6 86.9 311.6 56 286.5 0 255.6 0zM460.1 154.6C454.4 151.6 447.2 153.7 444.1 159.4 435.4 174.9 421.3 197.2 400 197.2 371.3 197.2 369.4 177.4 368.3 139.7 368.1 133.2 362.8 128 356.3 128H315.3C310.1 128 305.6 131.3 303.9 136.2 295 162.9 277.9 177.2 256 177.2S217 162.9 208.1 136.2C206.4 131.3 201.9 128 196.7 128H155.7C149.2 128 143.9 133.2 143.7 139.7 142.6 177.3 140.8 197.2 112 197.2 91.3 197.2 78.2 177 67.6 159.2 64.3 153.7 57.3 151.7 51.7 154.7L12.5 175.4A12-12 0 0 1 7 190.6L112 448H400L505 190.6A12-12 0 0 1 499.5 175.4L460.1 154.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/chess-queen.js
// module id = yBBt
// module chunks = 144